import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import styles from './StandardOverview.module.css';

const Delta = ({ delta, tone }) => {
    if (!delta || delta === '—') {
        return <span className={styles.indexDeltaNeutral}>—</span>;
    }
    const className =
        tone === 'up' ? styles.indexDeltaUp : tone === 'down' ? styles.indexDeltaDown : styles.indexDeltaNeutral;
    return <span className={className}>{delta}</span>;
};

const IndexScoresCard = ({ model }) => {
    const navigate = useNavigate();
    const view = model.indexScoresView;
    const { indexScores } = model;

    if (view?.rows?.length) {
        return (
            <OverviewCardShell
                title="Index Scores"
                compact
                headerAside={view.headerMeta ? <span className={styles.cardMetaTiny}>{view.headerMeta}</span> : null}
                footer={
                    view.actionLabel ? (
                        <OverviewTextAction onClick={() => navigate('/lens-intelligence')}>
                            {view.actionLabel}
                        </OverviewTextAction>
                    ) : null
                }>
                <ul className={styles.indexScoreBars}>
                    {view.rows.map(row => (
                        <li key={row.label} className={styles.indexScoreBarRow}>
                            <div className={styles.indexScoreBarHeader}>
                                <span className={styles.indexScoreBarLabel}>{row.label}</span>
                                <span className={styles.indexScoreBarValue}>
                                    {row.value} <Delta delta={row.delta} tone={row.deltaTone} />
                                </span>
                            </div>
                            <div className={styles.indexScoreBarTrack} aria-hidden>
                                <div
                                    className={
                                        row.barTone === 'green'
                                            ? styles.indexScoreBarFillGreen
                                            : styles.indexScoreBarFillAmber
                                    }
                                    style={{ width: `${row.barPercent ?? row.value}%` }}
                                />
                            </div>
                        </li>
                    ))}
                </ul>
            </OverviewCardShell>
        );
    }

    const hasScores =
        indexScores.maturity != null ||
        indexScores.security != null ||
        indexScores.governance != null ||
        (indexScores.teamAnalyser?.exemplary || 0) + (indexScores.teamAnalyser?.adequate || 0) + (indexScores.teamAnalyser?.development || 0) >
            0;

    return (
        <OverviewCardShell title="Index Scores" compact>
            {hasScores ? (
                <ul className={styles.indexScoreList}>
                    {indexScores.maturity != null ? (
                        <li>
                            Tech Maturity Index · <strong>{indexScores.maturity}</strong>
                        </li>
                    ) : null}
                    {indexScores.security != null ? (
                        <li>
                            Security Index · <strong>{indexScores.security}</strong>
                        </li>
                    ) : null}
                    {indexScores.governance != null ? (
                        <li>
                            Security Governance · <strong>{indexScores.governance}</strong>
                        </li>
                    ) : null}
                </ul>
            ) : (
                <p className={styles.cardDescription}>Not yet calculated — requires analysis to complete.</p>
            )}
        </OverviewCardShell>
    );
};

export default IndexScoresCard;
